import React from 'react';

const FontAwesomeIcon = ({ iconFamily, icon, onClick, title, className, colour = 'text-gray-600', hoverColour = 'hover:text-gray-900' }) => {
    return <span className={`${iconFamily ? iconFamily : 'fad'} fa-${icon} fa-lg ${colour} ${hoverColour} ${onClick ? 'cursor-pointer' : ''} ${className}`} onClick={onClick} title={title} />;
};

export default FontAwesomeIcon;
